
declare global {
    function assert(condition: unknown, message?: string): asserts condition;
}

(globalThis as any).assert = function (condition: unknown, message = 'Assertion failed'): asserts condition {
    if (!condition) {
        throw new Error(message);
    }
};

import * as import_1 from ".\/prolog.js";
export const imports={
...import_1,
}
